import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuOverlay from "@/components/MenuOverlay";
import { PRIMARY_SHOPIFY_URL } from "@/lib/shopify";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        data-testid="site-header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled
            ? "bg-black/75 backdrop-blur-xl border-b border-[#1a1a1a]"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
          <Link
            to="/"
            data-testid="header-logo"
            className="font-display text-[1.6rem] tracking-[0.32em] text-white"
            aria-label="AFRQA home"
          >
            AFRQA<span className="gold text-[0.65rem] align-super ml-0.5">™</span>
          </Link>

          {/* Compact desktop nav — luxury essentials only */}
          <nav
            className="hidden md:flex items-center gap-10 font-label text-[#cfcfca]"
            aria-label="Primary"
          >
            <Link
              to="/product/africa-frame"
              data-testid="nav-shop"
              className="link-underline hover:text-white transition-colors"
            >
              Shop
            </Link>
            <Link
              to="/journal"
              data-testid="nav-journal"
              className="link-underline hover:text-white transition-colors"
            >
              Journal
            </Link>
            <Link
              to="/vision"
              data-testid="nav-vision"
              className="link-underline hover:text-white transition-colors"
            >
              Vision
            </Link>
          </nav>

          <div className="flex items-center gap-4 md:gap-6">
            <button
              type="button"
              onClick={() => setMenuOpen(true)}
              data-testid="header-menu-btn"
              className="font-label text-[#cfcfca] hover:text-white flex items-center gap-3 transition-colors"
              aria-label="Open menu"
            >
              <span className="hidden sm:inline">Menu</span>
              <span aria-hidden className="flex flex-col gap-[5px]">
                <span className="block w-6 h-px bg-current" />
                <span className="block w-6 h-px bg-current" />
                <span className="block w-4 h-px bg-[#d4af37] ml-auto" />
              </span>
            </button>
            <a
              href={PRIMARY_SHOPIFY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-preorder-btn"
              className="hidden md:inline-flex font-label text-[#0a0a0a] bg-[#d4af37] hover:bg-[#f0c84d] px-5 py-2.5 transition-colors"
            >
              Preorder
            </a>
          </div>
        </div>
      </header>

      <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
